import { Extent } from 'ol/extent';

import { makeMockAPICall } from 'models/api';
import { BFMC, API as BFMCAPI } from 'models/bfmc';
import { API_URL } from 'config';

export declare namespace API {
    export interface Extent {
        xmin: number;
        ymin: number;
        xmax: number;
        ymax: number;
    }

    export interface Location {
        id: number;
        name: string;
        extent: Extent;
        bmc: BFMCAPI.BFMC['id'];
    }

    export interface ActionResponse {
        results: 'success' | 'error';
        error?: string;
    }
}

export interface Location {
    id: number;
    name: string;
    extent: Extent;
    bmc: BFMC['id'];
}

export type NewLocation = Omit<Location, 'id'>;

const LOCATION_ROUTE = `${API_URL}/location`;

export const mapAPIToLocation = ({
    extent,
    ...rest
}: API.Location): Location => ({
    ...rest,
    extent: [extent.xmin, extent.ymin, extent.xmax, extent.ymax],
});

export const sampleAPILocations: API.Location[] = [
    {
        id: 0,
        name: 'Sydney',
        extent: {
            xmin: 16752244.8671,
            xmax: 16861702.6916,
            ymin: -4046270.5293,
            ymax: -3952711.6067,
        },
        bmc: 0,
    },
    {
        id: 1,
        name: 'Newcastle',
        extent: {
            xmin: 16848861.2708,
            xmax: 16910775.2638,
            ymin: -3904862.027,
            ymax: -3842336.5378,
        },
        bmc: 0,
    },
    {
        id: 2,
        name: 'Hunter',
        extent: {
            xmin: 16797801.336,
            xmax: 16867817.6539,
            ymin: -3964177.1609,
            ymax: -3890491.8657,
        },
        bmc: 2,
    },
];

export const getLocations = makeMockAPICall<Location[], void, API.Location[]>(
    () => ({
        url: LOCATION_ROUTE,
    }),
    (raw) => raw.map(mapAPIToLocation),
    sampleAPILocations,
    250,
);

export const addLocation = makeMockAPICall<
    API.ActionResponse,
    { location: NewLocation },
    API.ActionResponse
>(
    ({ location }) => ({
        url: `${LOCATION_ROUTE}/${location}`,
        method: 'POST',
    }),
    (x) => x,
    { results: 'success' },
    500,
);

export const removeLocation = makeMockAPICall<
    API.ActionResponse,
    { location: Location['id'] },
    API.ActionResponse
>(
    ({ location }) => ({
        url: `${LOCATION_ROUTE}/${location}`,
        method: 'DELETE',
    }),
    (x) => x,
    { results: 'success' },
    500,
);
